import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, effect, untracked } from '@angular/core';
const _c0 = ["*"];
class UxaProductIconComponent {
  static {
    this.ɵfac = function UxaProductIconComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UxaProductIconComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: UxaProductIconComponent,
      selectors: [["ng-component"]],
      hostAttrs: ["role", "presentation"],
      hostVars: 18,
      hostBindings: function UxaProductIconComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("uxa-aqua", ctx.color === "aqua")("uxa-aquamarine", ctx.color === "aquamarine")("uxa-black", ctx.color === "black")("uxa-cerulean", ctx.color === "cerulean")("uxa-dark-blue", ctx.color === "dark-blue")("uxa-forest-green", ctx.color === "forest-green")("uxa-lime", ctx.color === "lime")("uxa-skyblue", ctx.color === "skyblue")("uxa-steelblue", ctx.color === "steelblue");
        }
      },
      inputs: {
        color: "color"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function UxaProductIconComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UxaProductIconComponent, [{
    type: Component,
    args: [{
      standalone: true,
      template: '<ng-content></ng-content>',
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        role: 'presentation',
        '[class.uxa-aqua]': 'color === "aqua"',
        '[class.uxa-aquamarine]': 'color === "aquamarine"',
        '[class.uxa-black]': 'color === "black"',
        '[class.uxa-cerulean]': 'color === "cerulean"',
        '[class.uxa-dark-blue]': 'color === "dark-blue"',
        '[class.uxa-forest-green]': 'color === "forest-green"',
        '[class.uxa-lime]': 'color === "lime"',
        '[class.uxa-skyblue]': 'color === "skyblue"',
        '[class.uxa-steelblue]': 'color === "steelblue"'
      }
    }]
  }], null, {
    color: [{
      type: Input
    }]
  });
})();

/**
 * Explicit effect is similar to a regular effect, but allows you to specify the dependencies of the effect as an argument.
 * This is useful when you don't actually care about the value of the dependencies, but you want to ensure that the effect
 * is run whenever the dependencies change. The effect callback function is also automatically run untracked.
 * Inspired by https://github.com/ngxtension/ngxtension-platform/blob/main/libs/ngxtension/explicit-effect/src/explicit-effect.ts
 */
function explicitEffect(deps, fn, options) {
  return effect(onCleanup => {
    const values = deps.map(s => s());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    untracked(() => fn(values, onCleanup));
  }, options);
}

/**
 * Generated bundle index. Do not edit.
 */

export { UxaProductIconComponent, explicitEffect };
